import React, { PureComponent } from "react";
import logoFooter from "../../assets/images/logo.png";
import "./footer.css";

class Footer extends PureComponent {
  render() {
    return (
      <footer>
        <div className="footer-wrapper">
          <img src={logoFooter} alt="Logo" className="footer-logo" />
          <span className="footer-copy">Developer by Eduardo Santos and Sophia Pinto &copy;&nbsp;2021</span>
          <div className="footer-navbar">
            <a href="/" className="footer-link">
              Termos de uso
            </a>
            <a href="/" className="footer-link">
              Política de privacidade
            </a>
            <a href="/" className="footer-link">
              Conheça o Inova Maranhão
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
